function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m12.089 6.5173 4.0742-1.6072 1.5325-4.3358h4.8591l1.4204 4.5601 4.1863 1.4951 4.0742-1.8315 3.4014 3.364-2.1305 3.8499 1.6446 4.2984 4.4106 1.4951v4.6722l-4.2984 1.4951-1.7568 3.962 2.3548 4.2984-3.7378 3.4014-4.0742-2.0931-4.0742 1.7194-1.5325 4.1863h-4.8965l-1.4951-4.2984-3.7378-1.4951-4.2984 1.8689-3.2519-3.2892 1.7194-4.4106-1.383-3.7378-4.5601-1.6072v-4.5601l4.3358-1.6072 1.6072-4.0742-2.0931-4.2984 3.4014-3.4014z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m12.089 6.5173 4.0742-1.6072 1.5325-4.3358h4.8591l1.4204 4.5601 4.1863 1.4951 4.0742-1.8315 3.4014 3.364-2.1305 3.8499 1.6446 4.2984 4.4106 1.4951v4.6722l-4.2984 1.4951-1.7568 3.962 2.3548 4.2984-3.7378 3.4014-4.0742-2.0931-4.0742 1.7194-1.5325 4.1863h-4.8965l-1.4951-4.2984-3.7378-1.4951-4.2984 1.8689-3.2519-3.2892 1.7194-4.4106-1.383-3.7378-4.5601-1.6072v-4.5601l4.3358-1.6072 1.6072-4.0742-2.0931-4.2984 3.4014-3.4014z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-secondary",
  d: "m9.5101 20.011c0-5.8309 4.7843-10.615 10.615-10.615 5.8683 0 10.615 4.7843 10.615 10.615 0 5.8683-4.747 10.615-10.615 10.615-5.8309 0-10.615-4.747-10.615-10.615z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m9.5101 20.011c0-5.8309 4.7843-10.615 10.615-10.615 5.8683 0 10.615 4.7843 10.615 10.615 0 5.8683-4.747 10.615-10.615 10.615-5.8309 0-10.615-4.747-10.615-10.615",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-primary",
  d: "m18.182 20.011c0-1.0466 0.85969-1.9436 1.8689-1.9436 1.0466 0 1.8689 0.89706 1.8689 1.9436 0 1.084-0.82231 1.9436-1.8689 1.9436-1.0092 0-1.8689-0.85969-1.8689-1.9436z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m18.182 20.011c0-1.0466 0.85969-1.9436 1.8689-1.9436 1.0466 0 1.8689 0.89706 1.8689 1.9436 0 1.084-0.82231 1.9436-1.8689 1.9436-1.0092 0-1.8689-0.85969-1.8689-1.9436",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-primary",
  d: "m24.162 20.011c0-1.0466 0.85969-1.9436 1.8689-1.9436 1.0466 0 1.8689 0.89706 1.8689 1.9436 0 1.084-0.82231 1.9436-1.8689 1.9436-1.0092 0-1.8689-0.85969-1.8689-1.9436z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m24.162 20.011c0-1.0466 0.85969-1.9436 1.8689-1.9436 1.0466 0 1.8689 0.89706 1.8689 1.9436 0 1.084-0.82231 1.9436-1.8689 1.9436-1.0092 0-1.8689-0.85969-1.8689-1.9436",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-primary",
  d: "m11.944 20.109c0-1.0466 0.85969-1.9436 1.8689-1.9436 1.0466 0 1.8689 0.89706 1.8689 1.9436 0 1.084-0.82231 1.9436-1.8689 1.9436-1.0092 0-1.8689-0.85969-1.8689-1.9436z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m12.128 20.109c0-1.0466 0.85969-1.9436 1.8689-1.9436 1.0466 0 1.8689 0.89706 1.8689 1.9436 0 1.084-0.82231 1.9436-1.8689 1.9436-1.0092 0-1.8689-0.85969-1.8689-1.9436",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSurveyModelTabSettings = function SvgSurveyModelTabSettings(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurveyModelTabSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Survey-Model-Tab-Settings.7fd15c90.svg";
export { ForwardRef as ReactComponent };